module.exports = __webpack_public_path__ + "img/Werwolf.b2ecc84d.svg";